import React from "react";
import NotFound from "./error";

export default function IndexPage() {
  return <NotFound />;
}
